import Vue from 'vue'
import Router from 'vue-router'
import home from '@/components/home'
import login from '@/components/login'
import MultiPanel from '@/components/MultiPanel'
import recharge from '@/components/recharge'
import reset from '@/components/reset'

import Main from '@/components/main.vue'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Main',
      component: Main,
      redirect: '/login',
      children: [
        { path: '/home', name: 'home', component: resolve => require(['@/components/home'], resolve) },
        { path: '/media', name: 'media', component: resolve => require(['@/components/MediaAudit'], resolve) },
        { path: '/webpage', name: 'webpage', component: resolve => require(['@/components/WebpageAudit'], resolve) },
        {
          path: '/MultiPanel',
          name: 'MultiPanel',
          component: resolve => require(['@/components/MultiPanel'], resolve),
        },
        {
          path: '/reset',
          name: 'reset',
          component: resolve => require(['@/components/reset'], resolve),
        },
        {
          path: '/order',
          name: 'order',
          component: resolve => require(['@/components/order'], resolve),
        },
        {
          path: '/orders',
          name: 'orders',
          component: resolve => require(['@/components/orders'], resolve),
        },
        {
          path: '/recharge',
          name: 'recharge',
          component: resolve => require(['@/components/recharge'], resolve),
        },
        {
          path: '/apis',
          name: 'api',
          component: resolve => require(['@/components/api'], resolve),
        },
        {
          path: '/orderList',
          name: 'orderList',
          component: resolve => require(['@/components/orderList'], resolve),
        },
        {
          path: '/userControl',
          name: 'userControl',
          component: resolve => require(['@/components/userControl'], resolve),
        },
        {
          path: '/base_setting',
          name: 'CommonSetting',
          component: () => import('@/components/setting/CommonSetting'),
          children: [
            { path: '/base_setting', name: 'baseSetting', component: () => import('@/components/setting/baseSetting.vue') },
            { path: '/user_setting', name: 'userSetting', component: () => import('@/components/setting/userSetting.vue') }
          ]
        },
        {
          path: '/custom',
          name: 'custom',
          redirect: '/custom/TypoCustom',
          component: resolve => require(['@/components/custom'], resolve),
          children: [
            {
              path: '/custom/TypoCustom',
              name: 'TypoCustom',
              component: resolve => require(['@/components/TypoCustom'], resolve),
            },
            {
              path: '/custom/sensitive',
              name: 'sensitive',
              component: resolve => require(['@/components/sensitive'], resolve),
            },
            {
              path: '/custom/SensitiveExclude',
              name: 'SensitiveExclude',
              component: resolve => require(['@/components/CustomSensitiveExclude'], resolve),
            },
            {
                path: '/custom/TypoExclude',
                name: 'CustomTypoExclude',
                component: resolve => require(['@/components/setting/CustomTypoExclude'], resolve)
            },
            { path: '/custom/CustomRank', name: 'CustomRank', component: resolve => require(['@/components/setting/CustomRank'], resolve) },
            { path: '/custom/CustomIndustry', name: 'CustomIndustry', component: resolve => require(['@/components/setting/IndustrySetting'], resolve) }
          ]
        },
        {
          path: '/topUp',
          name: 'topUp',
          component: resolve => require(['@/components/topUp'], resolve),
        },
        {
          path: '/invoice',
          name: 'invoice',
          component: resolve => require(['@/components/invoice'], resolve),
        },
        { path: '/invoice-ctrl', name:'InvoiceControl', component: resolve => require(['@/components/InvoiceControl.vue'], resolve) },
        {
          path: '/invoices',
          name: 'invoices',
          component: resolve => require(['@/components/invoices'], resolve),
        },
        { path: '/payrecord', name: 'payrecord', component: resolve => require(['@/components/PayRecord'], resolve) },
        {
          path: '/login',
          name: '登录',
          meta: {
            requireAuth: true  //添加该字段 表示进入到这个页面是需要登录成功以后的
          },
          component: resolve => require(['@/components/login'], resolve),

        }]
    },

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js